// @ts-nocheck
const FEATURES = [
  { n: "01", title: "Legal AI",           tag: "Core",       desc: "Contract review and risk scoring in seconds, not hours. Grounded in your contract's governing law.",
    icon: <><rect height="15" rx="1.5" width="12" x="3" y="1.5"/><line x1="5.5" x2="12.5" y1="6" y2="6"/><line x1="5.5" x2="12.5" y1="9" y2="9"/></> },
  { n: "02", title: "AI Redlining",       tag: "Legal AI",   desc: "Propose clause changes, negotiate, share annotated drafts with counterparty.",
    icon: <><path d="M3 13l5-5 2 2-5 5H3v-2z"/><line x1="8" x2="13" y1="5" y2="10"/></> },
  // "Case Research — citation-verified case law" until 2026-09-18: legal research
  // is India-only (404 here) and the adapters verify statutes, not case law.
  { n: "03", title: "Governing Law",       tag: "Legal AI",   desc: "The clause decides which law applies — unknown is a real answer, never a guess — and the analysis is grounded in that law.",
    icon: <><circle cx="7.5" cy="7.5" r="5.5"/><line x1="11.5" x2="16" y1="11.5" y2="16"/></> },
  // "Regulatory monitoring. Alerts 14 days before every filing deadline." until
  // 2026-10-08 — the statutory calendar is India-only. Global Compliance AI is
  // the privacy programme (privacy_compliance, Pro and above).
  { n: "04", title: "Privacy Programme",  tag: "Compliance", desc: "Your privacy programme under your country's law — 14 law packs, rights requests, breach clocks, retention. Every pack marked drafted.",
    icon: <><path d="M9 2L15 4.5V11L9 16L3 11V4.5L9 2Z"/><polyline points="6,9 8,11 12,7"/></> },
  { n: "05", title: "Workflow Agents",    tag: "Automation", desc: "No-code AI agents spanning legal and compliance workflows.",
    icon: <><rect height="4" rx="1.2" width="5" x="1.5" y="7"/><rect height="4" rx="1.2" width="5" x="11.5" y="2"/><rect height="4" rx="1.2" width="5" x="11.5" y="12"/><line x1="6.5" x2="11.5" y1="9" y2="4"/><line x1="6.5" x2="11.5" y1="9" y2="14"/></> },
  { n: "06", title: "Legal Health Score", tag: "Analytics",  desc: "One number. Every contract risk tracked over time. Trends at a glance.",
    icon: <><polyline points="2,12 6,7 9,10 13,5 16,8"/><line x1="2" x2="16" y1="15" y2="15"/></> },
  { n: "07", title: "Matter File",        tag: "Documents",  desc: "Every document filed by category to its matter. Analysis when you ask for it; identity documents never reach an AI vendor.",
    icon: <><rect height="9" rx="1.2" width="12" x="3" y="8"/><path d="M6 8V6a3 3 0 016 0v2"/></> },
  { n: "08", title: "Case Studio",        tag: "Matters",    desc: "Issues, claims, contradictions and evidence gaps proposed from the file's verified facts — a person accepts each one.",
    icon: <><circle cx="9" cy="9" r="6.5"/><polyline points="6,9 8,11 12,7"/></> },
  { n: "09", title: "Client Portal",      tag: "Clients",    desc: "Scoped shares, uploads and approvals. Clients sign in with a one-time link to the address you hold for them.",
    icon: <><rect height="12" rx="1.5" width="14" x="2" y="3"/><line x1="2" x2="16" y1="7" y2="7"/></> },
  { n: "10", title: "Command Centre",     tag: "Operations", desc: "Today across tasks, hearings, approvals, drafts awaiting review and renewals — each item a link to the work.",
    icon: <><polyline points="2,12 6,7 9,10 13,5 16,8"/><line x1="2" x2="16" y1="15" y2="15"/></> },
];

export default function HorizontalScroll() {
  return (
    <div className="hs-outer" id="hso">
      <div className="hs-sticky" id="hss">
        <div className="hs-hdr">
          <div className="ey">04 / All features</div>
          <h2 className="sh2">Everything you need.{" "}<br /><em>Scroll to explore.</em></h2>
        </div>
        <div className="hs-vp">
          <div className="hs-track" id="hst">
            {FEATURES.map((f) => (
              <div key={f.n} className="hcard">
                <div className="hcard-n">{f.n}</div>
                <div className="hcard-ico">
                  <svg fill="none" height="18" stroke="currentColor" strokeWidth="1.4" viewBox="0 0 18 18" width="18">
                    {f.icon}
                  </svg>
                </div>
                <div className="hcard-title">{f.title}</div>
                <div className="hcard-desc">{f.desc}</div>
                <div className="hcard-tag">{f.tag}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="hs-prog" id="hsp">
          {FEATURES.map((f, i) => (
            <div key={f.n} className={`hpp${i === 0 ? " active" : ""}`}></div>
          ))}
        </div>
      </div>
    </div>
  );
}
